import React from "react";

function Spinner() {
  return (
    <svg
      height="16"
      width="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="5.5"
        fill="none"
        strokeLinecap="round"
        strokeDasharray="16 19"
      />
    </svg>
  );
}

export default Spinner;
